<template>
  <div class="v-flat-file">
    <VButton
      key="import-csv"
      type="primary"
      label="Import"
      size="sm"
      extraClass="csv-upload"
      :onClickHandler="launch"
      inverted
      noBorder
    ></VButton>

    <ContactsFlatFileTagsModal
      v-if="tagsOpened"
      @close="_onTagsClose"
      @submit="_onTagsSubmit"
    />
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import FlatfileImporter from "flatfile-csv-importer";
import { flatFileKey } from "@/config";

import variables from "@/styles/_variables.scss";

// components
import VButton from "@/components/VButton";
import ContactsFlatFileTagsModal from "@/components/ContactsFlatFileTagsModal";

const overridingStyles = {
  borderRadius: "4px", // Flatfile wrapper, modals, & buttons
  primaryButtonColor: variables.primary, // Primary buttons
  linkColor: "#c6d1dd", // Links
  linkAltColor: "#4a90e2", // :hover, :active, & :focus states of links
  primaryTextColor: "#50535b", // Main text color, background-color of certain buttons
  secondaryTextColor: "#9daab6", // 'Dimmed' text
  errorColor: variables.dangerColor, // Invalid and error indicator borders, icons, and text
  successColor: variables.successColor, // Success text, buttons, icons, toggles, required indicators
  warningColor: "#f6a623", // Warning text and icons
  borderColor: "#e8e8e8", // Flatfile wrapper, modals, and some buttons
  fontFamily: "lato, sans-serif" // Main font
};

FlatfileImporter.setVersion(2);

export default Vue.component("VFlatFileImporter", {
  props: {
    config: VueTypes.object,
    setupCustomer: VueTypes.bool.def(true),
    customer: VueTypes.shape({
      userId: VueTypes.string,
      email: VueTypes.string,
      companyName: VueTypes.string
    }),

    // function which invokes after successfully getting info
    // common use - to push data into parent
    onSuccess: VueTypes.func,
    onCancel: VueTypes.func,

    recordHookHandler: VueTypes.func
  },

  component: {
    VButton,
    ContactsFlatFileTagsModal
  },

  data() {
    return {
      fullConfig: {
        license: flatFileKey,
        type: "Contacts",
        allowInvalidSubmit: false,
        managed: true,
        allowCustom: true,
        disableManualInput: true,
        styleOverrides: overridingStyles,
        integrations: {
          adobeFontsWebProjectId: "cqr3osx"
        },
        ...this.config
      },

      tagsOpened: false,
      importer: null,
      importResults: null
    };
  },

  methods: {
    launch() {
      const $v = this;
      if (this.setupCustomer && this.customer) {
        this.importer.setCustomer(this.customer);
      }

      this.importer
        .requestDataFromUser()
        .then(function(results) {
          const { batchId: batch_id, fileName: file_name, validData } = results;
          $v.importResults = {
            batch_id,
            file_name,
            total_items: validData.length
          };

          $v.tagsOpened = true;
          $v.importer.close();
        })
        .catch(function() {
          if (error) {
            $v.importer.displayError(
              "Something went wrong during uploading your file. Please, contact support."
            );
          }
        });
    },

    _onTagsClose() {
      this.tagsOpened = false;
      this.importResults = null;
    },

    _onTagsSubmit(tags) {
      const data = {
        ...this.importResults,
        tags
      };

      this.$emit("success", data);
      this.onSuccess && this.onSuccess(data);
      this.tagsOpened = false;
    }
  },

  mounted() {
    if (!this.importer) {
      const { license, ...rest } = this.fullConfig;
      this.importer = new FlatfileImporter(license, { ...rest });

      if (this.recordHookHandler) {
        this.importer.registerRecordHook(this.recordHookHandler);
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.v-flat-file {
  display: inline-block;
  margin-right: 12px;
}
</style>

<style lang="scss">
button.sm.primary.csv-upload {
  font-size: 15px;
}
</style>
